import React from "react"
import styled from "styled-components"

import {
  PrismicImage,
  StyledHeading,
  BodyCopy,
  CallToAction,
  StandardContainer,
  SectionWrapper,
} from "../../common"

import { VideoBlock } from "../other/videoBlock"

export const ImageText = ({
  image,
  heading,
  text_content,
  layout,
  link_type,
  link_text,
  link_target,
  page_link,
  anchor_id,
  block_background,
  mobile_align,
  isBlog,
  quote_block,
  category,
  video_embed,
  video_url,
  bottom_padding,

  second_link_type,
  second_link_text,
  second_link_target,
  second_link,
  second_link_colour,
}) => {
  const { category_color } = category?.document?.data || {}

  const StyledImageText = styled(StandardContainer)`
    margin: 0 auto;
    padding: ${(props) => (isBlog ? "2rem" : props.theme.spacers.med)}
      ${(props) => props.theme.padding.hMobile};
    background-color: ${quote_block && category_color && category_color + "20"};
    background-clip: content-box;

    h1,
    h2,
    h3 {
      line-height: 1.3;
    }

    @media ${(props) => props.theme.breakpoints.ns} {
      margin: 0 auto;
      padding: ${(props) =>
        quote_block
          ? "2.5rem 3vw 2.5rem 3vw"
          : isBlog
          ? "1rem 3vw 1rem 3vw"
          : bottom_padding
          ? "8rem 3vw 0rem 3vw"
          : "8rem 3vw 8rem 3vw"};

      display: flex;
      align-items: stretch;
      flex-direction: ${(props) =>
        props.layout === "Image left"
          ? "row"
          : props.layout === "Image right"
          ? "row-reverse"
          : "row"};

      p,
      a,
      span,
      b,
      i,
      h4,
      h5,
      h6 {
        padding: ${layout === "Image left" && quote_block
          ? "0 50px 0 0"
          : quote_block && layout === "Image right" && "0 0 0 50px"};
        font-size: ${quote_block ? "20px" : isBlog && !quote_block && "14px"};
      }
    }

    p,
    a,
    span,
    b,
    i,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${quote_block && category_color};
      font-weight: ${quote_block && "600"};
      text-align: ${quote_block && "center"};
      font-style: ${quote_block && "italic"};
      line-height: ${quote_block && "28.88px"};
    }
    a {
      width: fit-content !important;

      @media (max-width: 480px) {
        margin-left: auto;
        margin-right: auto;
      }
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        background-image: url("https://images.prismic.io/trev/ade1bb0f-e63a-46a3-8539-671161175c13_check.png?auto=compress,format");
        background-repeat: no-repeat;
        background-size: 22px;
        background-position: 0px 5px;
        margin: 0;
        padding: 0 0 0 40px;
      }
    }
  `

  const TextWrapper = styled.div`
    width: 100%;
    text-align: ${(props) => (props.$mobAlign === "Left" ? "left" : "center")};
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 20px 20px 20px;
    button {
      margin-left: auto;
      margin-right: auto;
    }
    @media ${(props) => props.theme.breakpoints.ns} {
      margin-top: 0;
      text-align: left;
      width: 60%;
      padding: ${(props) =>
        props.layout === "Image left"
          ? "20px 0 20px 50px"
          : props.layout === "Image right"
          ? "20px 50px 20px 0"
          : "20px 0 20px 50px"};
      button {
        margin-left: 0;
        margin-right: 0;
      }
    }
    @media ${(props) => props.theme.breakpoints.large} {
      text-align: left;
      width: ${(props) =>
        isBlog && props.$quote_block ? "50%" : isBlog ? "61%" : "55%"};
      padding: ${(props) =>
        props.layout === "Image left"
          ? "20px 0 20px 50px"
          : props.layout === "Image right"
          ? "20px 50px 20px 0"
          : "20px 0 20px 50px"};
    }
  `

  const ImageWrapper = styled.div`
    width: 100%;
    .gatsby-image-wrapper {
      width: 100%;
    }
    @media ${(props) => props.theme.breakpoints.ns} {
      width: 40%;
      display: flex;
      align-items: ${(props) => (props.$quote_block ? "stretch" : "center")};
    }
    @media ${(props) => props.theme.breakpoints.large} {
      width: ${isBlog && quote_block ? "50%" : isBlog ? "39%" : "45%"};
      display: flex;
      align-items: ${(props) => (props.$quote_block ? "stretch" : "center")};
    }

    img {
      height: ${(props) => (props.$quote_block ? "100%" : "auto")} !important;
      object-fit: cover;
    }

    > div {
      width: 100%;

      .video-block {
        padding: 0 !important;
      }

      .play-button {
        width: 100% !important;
        left: 0 !important;
      }
    }
  `

  const StyledButtons = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    column-gap: 2rem;

    @media (min-width: 500px) {
      flex-direction: row;
    }
  `

  return (
    <SectionWrapper $bgColor={block_background}>
      <StyledImageText layout={layout} id={anchor_id} $wrappedStandard>
        <ImageWrapper $quote_block={quote_block}>
          {video_embed?.embed_url ? (
            <VideoBlock
              poster_image={image}
              full_video={{ url: video_embed?.embed_url }}
            />
          ) : (
            <PrismicImage {...image} />
          )}
        </ImageWrapper>
        <TextWrapper
          layout={layout}
          $mobAlign={mobile_align}
          $quote_block={quote_block}
        >
          <StyledHeading size={isBlog ? "h4" : "h2"}>
            {heading?.text}
          </StyledHeading>
          <BodyCopy dangerouslySetInnerHTML={{ __html: text_content?.html }} />

          <StyledButtons>
            <CallToAction
              type={link_type}
              text={link_text}
              target={link_target}
              page={page_link}
            />

            <CallToAction
              type={second_link_type}
              text={second_link_text}
              target={second_link_target}
              page={second_link}
              colour={second_link_colour}
            />
          </StyledButtons>
        </TextWrapper>
      </StyledImageText>
    </SectionWrapper>
  )
}
